import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import nonEmpty from '../utils/nonEmpty';

const USE_SSO_PLATFORM_QUERY = gql(/** @complexity 6 */ `
  query useSSOPlatforms {
    currentSession {
      organization {
        id
        integrations {
          id
          platform
          settings {
            enableSso
          }
        }
      }
    }
  }
`);

export default () => {
  const { data } = useQuery(USE_SSO_PLATFORM_QUERY);

  return (
    data?.currentSession?.organization?.integrations
      ?.filter((i) => i?.settings?.enableSso)
      .map((i) => i?.platform)
      .filter(nonEmpty) || null
  );
};
